/* eslint-disable prefer-destructuring */
import { NAME_DOCUMENT_FOR_GAME_INFOR, ENUM_STATUS_GAME } from "constants"

import React, { useState, useEffect, useMemo, useRef } from "react"

import CustomButton from "components/CustomButton"
import Modal from "components/Modal"
import { updateDocument } from "firebase-helper/firestore-services"
import { uploadFileByBase64, downloadURL } from "firebase-helper/storage-services"
import useEventListener from "hooks/useEventListener"
import { FaCamera } from "react-icons/fa"
import { useScreenshot } from "use-react-screenshot"
import { getTextByShadow, getPointBySeriAndShadow, loadImage , showNotification } from "utils"
import { v4 as uuidv4 } from "uuid"


import Title from "../common/Title"

const Equal = ({ infor, roomId, userId, users }) => {
    const { series, shadow } = infor

    const leftCanvasRef = useRef(null)
    const leftImageRef = useRef(null)
    const leftCanvasWrapperRef = useRef(null)
    const rightCanvasRef = useRef(null)
    const rightCanvasWrapperRef = useRef(null)
    const ref = useRef(null)

    const [image, takeScreenshot] = useScreenshot()

    const [leftSeri, setLeftSeri] = useState(null)
    const [rightSeri, setRightSeri] = useState(null)
    const [isScreenshotModalDisplayed, setIsScreenshotModalDisplayed] = useState(false)
    const [urlScreenshot, setUrlScreenshot] = useState("")

    const drawCanvas = async(canvasRef, canvasWrapperRef, seri) => {
        const canvas = canvasRef.current
        const ctx = canvas.getContext("2d")

        canvas.width = canvasWrapperRef.current.clientWidth

        const background = await loadImage(
            "https://firebasestorage.googleapis.com/v0/b/daudit-145c2.appspot.com/o/dolla_result.jpg?alt=media&token=0cf422e0-05d8-49ab-9ed5-e7e09d2a1d74"
        )
        const w = background.width
        const h = background.height

        const ratio = canvas.width / w
        canvas.height = h * ratio

        ctx.drawImage(background, 0, 0, w * ratio, h * ratio)

        const canvasW = canvas.width
        const canvasH = canvas.height

        ctx.font = `${27 * ratio}px Arial`
        const text = `PO ${seri}`.split("").join(String.fromCharCode(8202))

        ctx.fillText(text, canvasW * 0.1, canvasH * 0.71)

        const { indexes } = shadow
        indexes.forEach((index) => {
            ctx.fillStyle = "#aa223b"
            ctx.fillRect(
                (0.262 + index * 0.053) * canvasW,
                0.74 * canvasH,
                0.04 * canvasW,
                0.02 * canvasH
            )
        })
    }

    useEffect(() => {
        const getImageScreenshots = async() => {
            if (!image){
                return
            }

            const url = `/equals/${uuidv4()}`
            await uploadFileByBase64(image, url)

            const urlScreen = await downloadURL(url)
            if (urlScreen){
                showNotification("", "Bạn yêu đã chụp ảnh màn hình", {
                    autoClose: 1998
                })
                setUrlScreenshot(urlScreen)
                setIsScreenshotModalDisplayed(true)
            }
        }

        getImageScreenshots()
    }, [image])

    useEffect(() => {
        let tempLeftSeri = series[0]
        let tempRightSeri = series[1]
        if (
            (userId === infor.userid_set_shadow && !infor.shadow.is_hand_left) ||
            (userId !== infor.userid_set_shadow && infor.shadow.is_hand_left)
        ){
            tempLeftSeri = series[1]
            tempRightSeri = series[0]
        }

        setLeftSeri(tempLeftSeri)
        setRightSeri(tempRightSeri)
    }, [])

    const draw2Canvas = () => {
        if (!leftSeri || !rightSeri){
            return
        }
        drawCanvas(leftCanvasRef, leftCanvasWrapperRef, leftSeri)
        drawCanvas(rightCanvasRef, rightCanvasWrapperRef, rightSeri)
    }

    useEffect(() => {
        draw2Canvas()
    }, [leftSeri, rightSeri])

    useEventListener("resize", () => {
        draw2Canvas()
    })

    const handleDone = async() => {
        await updateDocument(NAME_DOCUMENT_FOR_GAME_INFOR, roomId, {
            status               : ENUM_STATUS_GAME.READY,
            shadow_user_is_ready : false,
            user_is_ready        : false
        })
    }

    const textShadow = useMemo(() => {
        return getTextByShadow(shadow)
    }, [])

    const handleCaptureScreenshot = () => {
        if (urlScreenshot){
            setIsScreenshotModalDisplayed(true)
        } else {
            takeScreenshot(ref.current)
        }
    }

    const showEqual = () => {
        let classNameFontColor = "text-quaternary"
        let equal = "Bạn yêu và đối phương đã hòa !!!"
        if (!leftSeri || !rightSeri){
            return
        }
        const myPoint = getPointBySeriAndShadow(leftSeri, shadow)
        const competitorPoint = getPointBySeriAndShadow(rightSeri, shadow)

        if (myPoint !== competitorPoint){
            const tempMyPoint = shadow.is_biggest_num ? myPoint : competitorPoint
            const tempCompetitorPoint = shadow.is_biggest_num ? competitorPoint : myPoint
            if (tempMyPoint > tempCompetitorPoint && myPoint !== 0){
                classNameFontColor = "text-primary--darknight"
                equal = "Bạn yêu đã thắng ^^"
            } else {
                classNameFontColor = ""
                equal = "Bạn yêu đã thua =="
            }
        }

        return (
            <p className={ `mt-4 text-center text-xl font-semibold ${classNameFontColor}` }>
                { equal }
            </p>
        )
    }

    const getName = (isMe = true) => {
        if (isMe){
            const user = users.find((u) => u.id === userId)
            if (user?.name){
                return user.name
            }
        } else {
            const tempUsers = users.filter((u) => u.id !== userId)
            const user = tempUsers[0]
            if (user?.name){
                return user.name
            }
        }

        return ""
    }

    return (
        <>
            <Modal
                close={ () => setIsScreenshotModalDisplayed(false) }
                isOpen={ isScreenshotModalDisplayed }
            >
                <div className="w-[280px] tablet:w-[480px] h-auto overflow-visible text-secondary px-4 py-8">
                    <p className="text-center text-lg font-semibold mb-2">Ảnh chụp màn hình</p>

                    <img alt="" className="border-solid	border-[3px] border-border rounded-lg" src={ urlScreenshot } />
                </div>
            </Modal>

            <div className="pb-4" ref={ ref }>
                <Title>3. Kết quả</Title>

                <p className="text-lg font-semibold tracking-wide text-center">
                    Bóng: { textShadow }
                </p>

                <div className="flex flex-col space-y-6 tablet:space-y-0 tablet:flex-row px-4 pt-4">
                    <div className="tablet:w-1/2 p-4 border-solid	 border-[3px] border-border rounded-lg	tablet:border-0 text-center ">
                        <p className="tablet:text-lg font-semibold mb-1 ">Tôi ({ getName() })</p>

                        <div className="relative" ref={ leftCanvasWrapperRef }>
                            <canvas ref={ leftCanvasRef } />

                            <img alt="" ref={ leftImageRef } />
                        </div>

                        { leftSeri && (
                            <>
                                <p className="mt-2 tracking-wider text-quinary">Seri: { leftSeri }</p>

                                <p className="font-semibold text-lg mt-1">
                                    Điểm: { getPointBySeriAndShadow(leftSeri, shadow) }
                                </p>
                            </>
                        ) }
                    </div>

                    <div className="tablet:w-1/2 p-4 border-solid	 border-[3px] border-primary--light rounded-lg text-center	tablet:border-0">
                        <p className="tablet:text-lg font-semibold mb-1 text-primary">
                            Đối phương ({ getName(false) })
                        </p>

                        <div ref={ rightCanvasWrapperRef }>
                            <canvas ref={ rightCanvasRef } />
                        </div>

                        { rightSeri && (
                            <>
                                <p className="mt-2 tracking-wider text-quinary">
                                    Seri: { rightSeri }
                                </p>

                                <p className="font-semibold text-lg mt-1">
                                    Điểm: { getPointBySeriAndShadow(rightSeri, shadow) }
                                </p>
                            </>
                        ) }
                    </div>
                </div>

                { showEqual() }

                <p className="text-quinary text-sm font-normal mt-2 text-center">
                    { new Date().toLocaleString() }
                </p>
            </div>

            <div
                className="cursor-pointer fixed bottom-[214px] right-4 p-3 tablet:p-4 text-white bg-black rounded-full flex-center"
                onClick={ handleCaptureScreenshot }
            >
                <FaCamera size={ 24 } />
            </div>

            { users[0].id === userId && (
                <CustomButton className="w-full h-[44px] mt-8" onClick={ handleDone }>
                    Làm trận mới
                </CustomButton>
            ) }
        </>
    )
}

export default Equal
